var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Reorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17 2 L 14 5 L 17 8 L 17 6 L 19 6 L 19 19 L 15 19 L 15 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 6 C 21 4.9069372 20.093063 4 19 4 L 17 4 L 17 2 z M 3 4 L 3 6 L 13 6 L 13 4 L 3 4 z M 3 8 L 3 9 L 3 13 L 13 13 L 13 8 L 3 8 z M 5 10 L 11 10 L 11 11 L 5 11 L 5 10 z M 3 15 L 3 16 L 3 21 L 13 21 L 13 15 L 3 15 z M 5 17 L 11 17 L 11 19 L 5 19 L 5 17 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Reorder);
export default __webpack_public_path__ + "static/media/icons8-reorder.766393af.svg";
export { ForwardRef as ReactComponent };